import { render } from "./MonitoringList.vue?vue&type=template&id=19aa3662&scoped=true&ts=true"
import script from "./MonitoringList.vue?vue&type=script&lang=ts"
export * from "./MonitoringList.vue?vue&type=script&lang=ts"

import "./MonitoringList.vue?vue&type=style&index=0&id=19aa3662&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3687640787/src/biomass-frontend-pwc/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19aa3662"]])

export default __exports__